import React from 'react'
import { useTranslation } from 'react-i18next'
import InputField from '../../../../../component/formFields/InputField'
import DropDown from '../../../../../component/formFields/DropDown'
import { GetGovernmentLookup } from '../../../../../api/endpoints/Governments'
import SectionCard from '../shared/SectionCard'
import './style.css'

const EditContactInformation = ({ formHandler, providerInfo , isLoading }) => {
    const { t } = useTranslation()

    return (
        <SectionCard 
            title={t("contact-details")} 
            icon="mdi:contacts"
            className="edit-contact-info"
        >
            <div className="edit-form-grid">
                <InputField 
                    formHandler={formHandler} 
                    name={"email"} 
                    isLoading={isLoading}
                    type="email"
                    defaultValue={providerInfo?.email}
                />

                <InputField 
                    formHandler={formHandler} 
                    name={"phoneNumber"} 
                    isLoading={isLoading}
                    type="tel"
                    defaultValue={providerInfo?.phoneNumber}
                />

                <InputField 
                    formHandler={formHandler} 
                    name={"websiteUrl"} 
                    isLoading={isLoading}

                    type="url"
                    defaultValue={providerInfo?.websiteUrl}
                    isRequired={false}
                />

                <InputField 
                    formHandler={formHandler} 
                    isLoading={isLoading}

                    name={"mainAddress"} 
                    defaultValue={providerInfo?.mainAddress}
                />

                <DropDown 
                    label={"governmentIds"} 
                    endPoint={GetGovernmentLookup} 
                    isLoading={isLoading}

                    defaultValue={providerInfo?.locations} 
                    formHandler={formHandler}
                />
            </div>
        </SectionCard>
    )
}

export default EditContactInformation

